import { Editor } from "@tinymce/tinymce-react";
import { Component } from "react";
import { BaseMetaFieldsProps } from "./types";

export default class MetaEditor extends Component<BaseMetaFieldsProps<string>> {
  handleEditorChange = (content: string) => {
    this.props.onChange(content);
  };

  render() {
    console.log(this.props.meta.data);
    return (
      <Editor
        value={(this.props.meta.data as string) || ""}
        apiKey="vtket3qw20iend7m65rssjovxb9sacpceeez633wf6y4viir"
        init={{
          height: 250,
          menubar: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help wordcount",
          ],
          content_style: "body { font-size: 13px }",
          toolbar:
            "undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify |  bullist numlist outdent indent | removeformat | help | code",
        }}
        onEditorChange={this.handleEditorChange}
      />
    );
  }
}
